
const MenuBuilderObjects = {

    dropdown: {
        label: '{{lang}}Drop down',
        type: 'dropdown',
        icon: '/assets/icons/useful/down-arrow (2).png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', defaultValue: '{{lang}}Label' } },
        ],
    },


    page: {
        label: '{{lang}}Yonnect page',
        type: 'page',
        icon: '/assets/icons/useful/website.png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', placeholder: '{{lang}}Label' } },
            { type: 'AdvancedMultiTreeSelect', key: 'page', information: { isSearchable: true, label: '{{lang}}Page', address: 'getFramesApplet', filter: { appletPopulate: true, type: 'page' }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },
        ],
    },


    link: {
        label: '{{lang}}Link',
        type: 'link',
        icon: '/assets/icons/useful/link (2).png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', placeholder: '{{lang}}Label' } },
            { type: 'TextInput', key: 'url', information: { required: true, label: '{{lang}}URL', placeholder: 'https://mydomain.com' } },
        ],
    },


    action: {
        label: '{{lang}}Action',
        type: 'action',
        icon: '/assets/icons/useful/thunder.png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', defaultValue: '{{lang}}Label' } },
            { type: 'ImageInput', key: 'icon', information: { required: false, label: '{{lang}}Menu icon' } },

            { key: 'type', type: 'SelectInput', col: '12', information: { label: 'Action type', placeholder: 'Choose...', type: "local", items: [{ title: 'Run automation', value: 'runAutomation' }, { title: 'Show page', value: 'showPage' }, { title: 'Open page', value: 'openWindow' }, { title: '{{lang}}Print', value: 'doPrint' }, { title: '{{lang}}Save as PDF', value: 'savePDF' },{ title: 'View history', value: 'viewHistory' }, { title: 'Change stage', value: 'changeStage' }, { title: 'Next stage', value: 'nextStage' }, { title: 'Last stage', value: 'lastStage' }, { title: 'Change stage to ...', value: 'changeStageTo' }, { title: 'Send to', value: 'sendTo' }, { title: 'Send as ...', value: 'sendAs' }, { title: 'Request approval', value: 'requestApproval' }, { title: 'Download as pdf', value: 'downloadAsPdf' }, { title: 'Share', value: 'share' },], required: true } },

            {
                key: 'actionConfig.runAutomation', type: 'SelectInput', col: '12', information: { label: '{{lang}}Run Automation', type: 'api', address: 'getAutomations', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, required: true }, disabled: true,
                dependencies: [{
                    refKey: 'type', targetKey: 'actionConfig.runAutomation',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'runAutomation' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    // show:true,

                }]
            },
            {
                key: 'actionConfig.trigger', type: 'SelectInput', col: '12', information: { label: '{{lang}}flow', type: 'api', address: 'getAutomationTriggers', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: 'key' }, required: true }, disabled: true,
                dependencies: [{
                    refKey: 'actionConfig.runAutomation', targetKey: 'actionConfig.trigger',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.runAutomation' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.filter._id', value: '@data.runAutomation' }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },




            {
                key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}Page', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Page', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'page',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'showPage' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]

            },




            {
                key: 'pageParams', type: 'PageParamsInput', col: '12', information: { label: '{{lang}}Page params', placeholder: '{{lang}}fileds', required: false },
                dependencies: [{
                    refKey: ['type', 'page'], targetKey: 'pageParams',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 3: { id: 3, source: { value: '@data.page' }, operator: { value: '!=' }, target: { value: null } }, 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'showPage' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.page' }] }
                    }],
                    else: { show: false },
                    init: true,

                }],
            },

        ],
    },


}

const MenuBuilderItems = Object.values(MenuBuilderObjects)

export { MenuBuilderItems, MenuBuilderObjects }